/*****************************************************************************/
/*!
\file index.js
\date 2021
\brief
\Not for distribution
*/
/*****************************************************************************/
import * as React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import CssBaseline from '@mui/material/CssBaseline';

ReactDOM.render(
  <>
    <CssBaseline />
    <App />
  </>,
  document.getElementById('root')
);
